import { parse } from 'node-html-parser';
import { applyStyles } from './applyStyles';

const templateWebAddWizardStyles = (template) => {
  if (!template.body.includes('<style>')) {
    template.body = template.body.replace('{{#if response}}', '{{#if response}}<style></style>');
  }
  const root = parse(template.body);
  //TODO root.querySelector('.product-items')._rawAttrs.onload set breakpoint items
  //TODO email name truncate helper

  //handling display block for preview as by default the block is with display none
  template.wizardFormData.blockStyles.display = 'block';
  const blockElement = root.querySelector('.rlv-recommender');
  const fluidContainer = root.querySelector('style');
  const fluidContainerWidth = template.wizardFormData.blockStyles.width;

  if (template.wizardFormData.blockStyles.fluidContainer === 'true') {
    fluidContainer.innerHTML = `.rlv-recommender {max-width: ${template.wizardFormData.blockStyles.width}px;width:100%;margin:0 auto;padding:0 20px;}`;
  }
  delete template.wizardFormData.blockStyles.width;
  blockElement.setAttribute('style', applyStyles(template.wizardFormData.blockStyles, ''));
  template.wizardFormData.blockStyles.width = fluidContainerWidth;

  const fontWrapperElement = root.querySelector('.font-wrapper');
  fontWrapperElement.setAttribute('style', applyStyles(template.wizardFormData.generalFontStyles, ''));

  const titleElement = root.querySelector('#productBlockTitle');
  titleElement.setAttribute('style', applyStyles(template.wizardFormData.titleStyles, ''));

  const topCallToActionElement = root.querySelector('#productBlockTopCallToAction');
  if (topCallToActionElement) {
    topCallToActionElement.setAttribute('style', applyStyles(template.wizardFormData.topCallToActionStyles, ''));
    topCallToActionElement.innerHTML = template.wizardFormData.topCallToActionStyles?.content || '';
  }

  const bottomCallToActionElement = root.querySelector('#productBlockBottomCallToAction');
  if (bottomCallToActionElement) {
    bottomCallToActionElement.setAttribute('style', applyStyles(template.wizardFormData.bottomCallToActionStyles, ''));
    bottomCallToActionElement.innerHTML = template.wizardFormData.bottomCallToActionStyles?.content || '';
  }

  const discountBadgeElements = root.querySelectorAll('.rlv-discount-badge');
  discountBadgeElements.forEach((element) => {
    element.setAttribute('style', applyStyles(template.wizardFormData.discountBadgeStyles, ''));
  });

  const productNameElement = root.querySelectorAll('.productBlockProductTitle');
  productNameElement.forEach((element) => {
    element.setAttribute('style', applyStyles(template.wizardFormData.productNameStyles, ''));
  });

  const productPriceElement = root.querySelectorAll('.rlv-price-listPrice');
  productPriceElement.forEach((element) => {
    element.setAttribute('style', applyStyles(template.wizardFormData.productPriceStyles, ''));
  });

  const productDiscountPriceElement = root.querySelectorAll('.rlv-price-discountPrice');
  productDiscountPriceElement.forEach((element) => {
    element.setAttribute('style', applyStyles(template.wizardFormData.productDiscountPriceStyles, ''));
  });

  const productPriceDiscountedElement = root.querySelectorAll('.rlv-price-listPriceDiscounted');
  productPriceDiscountedElement.forEach((element) => {
    element.setAttribute('style', applyStyles(template.wizardFormData.productPriceDiscountedStyles, ''));
  });

  const applyArrowStyles = (root, arrowsStyles) => {
    const prevButtonStylesElement = root.querySelector('.btn-prev');
    arrowsStyles.width = typeof arrowsStyles.width === 'number' ? arrowsStyles.width + 'px' : arrowsStyles.width;
    const prevButtonStyles = {
      width: arrowsStyles.width,
      height: arrowsStyles.height,
      top: JSON.parse(arrowsStyles.centered) ? '50%' : arrowsStyles.top,
      position: arrowsStyles.position,
      'background-color': arrowsStyles['background-color'],
      float: 'left',
      left: arrowsStyles.left,
      border: arrowsStyles.border,
      'border-radius': arrowsStyles['border-radius'],
      'z-index': arrowsStyles['z-index'],
      'padding-top': arrowsStyles['padding-top'],
      'padding-left': arrowsStyles['padding-left'],
      'padding-right': arrowsStyles['padding-right'],
      'padding-bottom': arrowsStyles['padding-bottom'],
    };
    JSON.parse(arrowsStyles.centered)
      ? prevButtonStylesElement.setAttribute('style', applyStyles(prevButtonStyles, '').replace('50%px', '50%'))
      : prevButtonStylesElement.setAttribute('style', applyStyles(prevButtonStyles, ''));

    const nextButtonStylesElement = root.querySelector('.btn-next');
    arrowsStyles.width = typeof arrowsStyles.width === 'number' ? arrowsStyles.width + 'px' : arrowsStyles.width;
    const nextButtonStyles = {
      width: arrowsStyles.width,
      height: arrowsStyles.height,
      top: JSON.parse(arrowsStyles.centered) ? '50%' : arrowsStyles.top,
      position: arrowsStyles.position,
      'background-color': arrowsStyles['background-color'],
      float: 'right',
      right: arrowsStyles.right,
      border: arrowsStyles.border,
      'border-radius': arrowsStyles['border-radius'],
      'z-index': arrowsStyles['z-index'],
      'padding-top': arrowsStyles['padding-top'],
      'padding-left': arrowsStyles['padding-left'],
      'padding-right': arrowsStyles['padding-right'],
      'padding-bottom': arrowsStyles['padding-bottom'],
    };
    JSON.parse(arrowsStyles.centered)
      ? nextButtonStylesElement.setAttribute('style', applyStyles(nextButtonStyles, '').replace('50%px', '50%'))
      : nextButtonStylesElement.setAttribute('style', applyStyles(nextButtonStyles, ''));
  };

  const applyArrowsColorsStyles = (root, arrowsStyles) => {
    let arrowsColorsStyles = root.querySelector('.btn-next svg path');
    arrowsColorsStyles.setAttribute('stroke', arrowsStyles.stroke);
    arrowsColorsStyles.setAttribute('fill', arrowsStyles.fill);
    arrowsColorsStyles = root.querySelector('.btn-prev svg path');
    arrowsColorsStyles.setAttribute('stroke', arrowsStyles.stroke);
    arrowsColorsStyles.setAttribute('fill', arrowsStyles.fill);
  };

  const applyArrowStylesAndColors = (root, arrowsStyles) => {
    applyArrowStyles(root, arrowsStyles);
    applyArrowsColorsStyles(root, arrowsStyles);
  };

  applyArrowStylesAndColors(root, template.wizardFormData.arrowsStyles);

  return root.toString();
};

export default templateWebAddWizardStyles;
